import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function LoginForm({ loginData, setLoginData, busy, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div><Label>Email</Label><Input data-testid="login-email" type="email" required value={loginData.email} onChange={(e) => setLoginData({ ...loginData, email: e.target.value })} /></div>
      <div><Label>Password</Label><Input data-testid="login-password" type="password" required value={loginData.password} onChange={(e) => setLoginData({ ...loginData, password: e.target.value })} /></div>
      <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit">{busy ? "Signing in…" : "Log in"}</Button>
    </form>
  );
}
